// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
    factory('agentAssignment', ['$http', '$q', 'obexConstant', 'authService',
      ($http, $q, obexConstant, authService) => {
        return {
          getTravelAgentOrganizationsById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlTravelAgentOrganizations}/organization/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },

          addTravelAgentOrganizations(travelAgentOrganizationList) {
            const promises = _.map(travelAgentOrganizationList, travelAgentOrganization => {
              return authService.getAuthorizationHeader().then(authHeader => {
                const url = `${obexConstant.urlTravelAgentOrganizations}`;
                const postData = {
                  Id: travelAgentOrganization.Id,
                  MemberId: travelAgentOrganization.MemberId,
                  OrganizationId: travelAgentOrganization.OrganizationId,
                };
                return $http.post(url, postData, {
                  headers: authHeader,
                });
              });
            });
            return $q.all(promises);
          },

          deleteTravelAgentOrganizations(travelAgentOrganizationIdList) {
            const promises = _.map(travelAgentOrganizationIdList, travelAgentOrganization => {
              return authService.getAuthorizationHeader().then(authHeader => {
                const url =
                  `${obexConstant.urlTravelAgentOrganizations}/${travelAgentOrganization.TravelAgentOrganizationId}`;
                return $http.delete(url, {
                  headers: authHeader,
                });
              });
            });
            return $q.all(promises);
          },
        };
      },
    ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/agentAssignment.service.js